import { FC } from "react";
import { useTheme } from "@mui/material";
import { useMediaQuery } from "@kaltura/mediaspace-shared-utils";
import { Button, IconButton, Typography } from "@kaltura/ds-react-components";
import { Info24Icon, ArrowRight24Icon, Clear24Icon } from "@kaltura/ds-react-icons";
import { translate } from "@kaltura/mediaspace-shared-utils";
import { StyledTopBanner, StyledButtonsContainer, StyledTextContainer, StyledTopRow } from "./StyledComponents";

export interface TopBannerProps {
    /**
     * text to show on the banner (translated)
     */
    bannerText: string;

    /**
     * text to show on the button (translated)
     */
    buttonText: string;

    /**
     * link to open when clicking the button (attendee/studio view link)
     */
    buttonUrl: string;

    /**
     * should link be opened in the same tab or a new tab
     */
    buttonTarget: "_self" | "_blank";

    /**
     * Optional callback when the close button is clicked
     */
    onClose?: () => void;
}

export const TopBanner: FC<TopBannerProps> = ({ bannerText, buttonText, buttonUrl, buttonTarget, onClose }) => {
    const theme = useTheme();
    const isXsScreen = useMediaQuery(theme.breakpoints.down("sm"));

    const actionButton = (
        <Button
            startIcon={<ArrowRight24Icon />}
            href={buttonUrl}
            target={buttonTarget}
            className="kms-ds-top-banner-button-attendee-view"
        >
            {buttonText}
        </Button>
    );

    const closeButton = (
        <IconButton
            variant={"borderless"}
            onClick={onClose}
            aria-label={translate("Close notification")}
            className="kms-ds-top-banner-button-close"
        >
            <Clear24Icon />
        </IconButton>
    );

    return (
        <StyledTopBanner role="region" className="kms-ds-live-studio-top-banner">
            <StyledTopRow>
                <Info24Icon />
                <StyledTextContainer>
                    <Typography variant={"body2"}>{bannerText}</Typography>
                </StyledTextContainer>

                {!isXsScreen ? (
                    <StyledButtonsContainer>
                        {actionButton}
                        {closeButton}
                    </StyledButtonsContainer>
                ) : (
                    closeButton
                )}
            </StyledTopRow>
            {isXsScreen && actionButton}
        </StyledTopBanner>
    );
};

export default TopBanner;
